import * as d3 from 'd3'
export default {
  methods: {

    draw_Menus() {

      if(this.menus.visible != 'Y') return

      let menu = this.canvasForm
      .append('g')
      .attr('id', `MENUS_${this.localId}`)
      .attr('transform',`translate(${this.menus.x}, ${this.menus.y})`)

      let x_ = 0
      this.menus.list.forEach((d,i)=> {

        let item = menu
        .append('g')
        .attr('id', `SCH_${this.localId}_${i}`)
        .attr('transform',`translate(${x_}, 0)`)
        .attr('cursor', 'pointer')
        .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {

          d3.select(`#OUT_${this.localId}_${this.current.menu}`).attr('stroke', '#bcbcbc')
          d3.select(`#IN_${this.localId}_${this.current.menu}`).attr('fill', '#bcbcbc')

          this.current.menu = d.code
          d3.select(`#OUT_${this.localId}_${d.code}`).attr('stroke', '#44A9DF')
          d3.select(`#IN_${this.localId}_${d.code}`).attr('fill', '#44A9DF')
          this.link_Action(d) 
        })

        item
        .append('circle')
        .attr('id', `OUT_${this.localId}_${d.code}`)
        .attr('cx', 0).attr('cx', 0).attr('r', 5)
        .attr('fill', '#fff').attr('stroke', this.current.menu == d.code ? '#44A9DF' : '#bcbcbc')

        item 
        .append('circle')
        .attr('id', `IN_${this.localId}_${d.code}`)
        .attr('cx', 0).attr('cx', 0).attr('r', 2.5)
        .attr('fill', this.current.menu == d.code ? '#44A9DF' : '#bcbcbc')

        item 
        .append('text')
        .attr('x', 10).attr('y', 3.5)
        .attr('font-size', 11).attr('fill', '#333')
        .text(d.name)

        x_ += this.getNode(`#SCH_${this.localId}_${i}`) + 20
      })

      if(this.menus.align == 'auto') {
        let x = this.Canvas.CanvasWidth - this.getNode(`#MENUS_${this.localId}`) - 30
        d3.select(`#MENUS_${this.localId}`).attr('transform', `translate(${x}, ${this.menus.y})`)
      }
      
    },

  }
}